const getApiToken = () => {
  var pairs = _.toPairs({ name: "wbst-api-token" } || {});
  var metas = window.document.getElementsByTagName("meta");
  for (var i = 0; i < metas.length; i++) {
    var match = _.every(pairs, function (pair) {
      return metas[i].getAttribute(pair[0]) === pair[1];
    });
    if (match) {
      var attrs = {};
      if (typeof metas[i].getAttributeNames !== 'undefined') {
        _.forEach(metas[i].getAttributeNames(), function (attrName) {
          attrs[attrName] = metas[i].getAttribute(attrName);
        });
      }
      else {
        _.forEach(metas[i].attributes, function (attrName, attrValue) {
          attrs[String(attrName.name)] = attrName.nodeValue;
        });
      }
      return attrs.content;
    }
  }
}

export default getApiToken;
